module.exports = __webpack_public_path__ + "img/portraits_08_V.09794906.webp";